export default __webpack_public_path__ + "static/media/093-diagonal-arrow-1.897e26d8.png";